export enum ConnectWalletStep {
  CHOOSE_WALLET,
  NEON_CONNECT,
}
